<template>
  <div class="monitor flex-grow-1 d-flex flex-column"
  style="overflow-y: auto;overflow-x: hidden;">
    <div class="selector-container" :class="{'dark':skinType}">
      <SectionTitle title="服务器监控"></SectionTitle>
    </div>
    <el-row
      :gutter="40"
     class="service-monitor-container
      section-container d-flex align-items-center
       justify-content-between"
    >
      <el-col :span="5"
        v-for="(monitor, index) of serviceMonitorList"
        class="d-flex" :key="`monitor-${index}`">
        <ServiceMonitorItem class="flex-grow-1"
        :monitorItem="monitor"
        :iconInfo="iconList[index]"
      ></ServiceMonitorItem>
      </el-col>
    </el-row>
    <el-row class="none-height flex-grow-1" type="flex" :gutter="12">
      <el-col :span="12" class="d-flex">
        <SectionContainer class="flex-grow-1 d-flex align-items-stretch" title="实时监控">
          <div class="none-height d-flex flex-grow-1">
            <Charts :options="usageCPU" class="none-width flex-grow-1"></Charts>
            <Charts :options="usageMem" class="none-width flex-grow-1"></Charts>
          </div>
        </SectionContainer>
      </el-col>
      <el-col :span="12" class="d-flex">
        <SectionContainer class="flex-grow-1 d-flex align-items-stretch" title="硬盘监控">
          <div class="none-height d-flex flex-grow-1">
            <Charts :options="usageDiskC" class="none-width flex-grow-1"></Charts>
             <Charts :options="usageDiskD" class="none-width flex-grow-1"></Charts>
          </div>
        </SectionContainer>
      </el-col>
    </el-row>
    <el-row class="none-height flex-grow-1" style="margin-top:1rem"
     type="flex" :gutter="12">
      <el-col :span="12" class="d-flex">
        <SectionContainer
          title="流量监控"
          class="none-width flex-grow-1"
        >
          <template v-slot:header>
            <el-date-picker
              v-model="selectDate1"
              type="date"
              placeholder="选择日期"
              :default-value="new Date()"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="mini"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>
          <Charts :options="flowMonitoring" class="flex-grow-1"></Charts>
        </SectionContainer>
      </el-col>
      <el-col :span="12" class="d-flex">
        <SectionContainer
          title="使用趋势"
          class="d-flex flex-grow-1"
        >
          <template v-slot:header>
            <el-date-picker
              v-model="selectDate"
              type="date"
              placeholder="选择日期"
              :default-value="new Date()"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="mini"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>
          <Charts :options="trendAnalysis" class="flex-grow-1"></Charts>
        </SectionContainer>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import ServiceMonitorItem from '@/components/system-safety/components/service-monitor-item.vue';
import SectionTitle from '@/components/utils/section-title.vue';
import Charts from '@/components/general/chart.vue';
import SectionContainer from '@/components/utils/section-container.vue';
import { getHostInfo, getDataRang } from '@/api/monitor';
import { formatDate } from '@/utils/utils';

export default {
  name: 'monitor',
  components: {
    Charts,
    SectionContainer,
    SectionTitle,
    ServiceMonitorItem,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
          || (Date.now() - time.getTime()) > 30 * 24 * 60 * 60 * 1000;
        },
      },
      hostInfo: null,
      selectDate: formatDate(new Date(), 'yyyy-MM-dd'),
      selectDate1: formatDate(new Date(), 'yyyy-MM-dd'),
      today: formatDate(new Date(), 'yyyy-MM-dd'),
      usageList: null,
      routeName: null,
      flowList: null,
      trendAnalysisTimeout: null,
      flowMonitoringTimeout: null,
      serviceMonitorList: [],
      iconList: [
        {
          icon: 'iconcpu',
          frontColor: '#1D86F4',
          backColor: '#C6E2FF',
        },
        {
          icon: 'iconicon-GIS_yunhangguanli',
          frontColor: '#F6A664',
          backColor: '#F5DECB',
        },
        {
          icon: 'iconfuwu',
          frontColor: '#9D77FB',
          backColor: '#E1D7FA',
        },
        {
          icon: 'iconjincheng',
          frontColor: '#2D6AE3',
          backColor: '#C1D4F6',
        },
        {
          icon: 'iconnengxiaoguanli',
          frontColor: '#67C23A',
          backColor: '#E1F3D8',
        },
      ],
      serviceMonitorMap: new Map([
        ['CPU_processors', 'CPU核心数'],
        ['CPU_frequency', 'CPU频率'],
        ['Service_count', '服务数量'],
        ['Processes_count', '进程数量'],
        ['SYS_runningTime', '系统运行时长'],
      ]),
      serviceMonitorUnitMap: new Map([
        ['CPU_processors', ''],
        ['CPU_frequency', 'MHz'],
        ['Service_count', ''],
        ['Processes_count', ''],
        ['SYS_runningTime', '天'],
      ]),
    };
  },
  created() {
    this.routeName = this.$route.name;
    this.requestHostInfo();
    this.requestDataRang();
    this.requestFlowMonitoring();
  },
  computed: {
    usageCPU() {
      if (this.hostInfo == null) {
        return null;
      }
      return {
        series: [
          {
            type: 'gauge',
            startAngle: 225,
            endAngle: -45,
            radius: '90%',
            itemStyle: {
              color: '#58D9F9',
              shadowColor: 'rgba(0,138,255,0.45)',
              shadowBlur: 10,
              shadowOffsetX: 1,
              shadowOffsetY: 1,
            },
            progress: {
              show: true,
              roundCap: true,
              width: 6,
            },
            pointer: {
              icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
              length: '75%',
              width: 6,
              offsetCenter: [0, '5%'],
            },
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 6,
              },
            },
            axisTick: {
              splitNumber: 2,
              lineStyle: {
                width: 2,
                color: '#999',
              },
            },
            splitLine: {
              length: 10,
              lineStyle: {
                width: 3,
                color: '#999',
              },
            },
            axisLabel: {
              distance: 8,
              color: '#999',
              fontSize: 14,
            },
            detail: {
              valueAnimation: true,
              formatter: '{value} %',
              offsetCenter: [0, '80%'],
              fontSize: 18,
              color: 'auto',
            },
            title: {
              offsetCenter: [0, '100%'],
              fontWeight: 'bold',
              color: this.skinType ? '#fff' : '#000',
            },
            data: [
              {
                value: this.hostInfo.Host.CPU_usage,
                name: 'CPU',
              },
            ],
          },
        ],
      };
    },
    usageMem() {
      if (this.hostInfo == null) {
        return {};
      }
      return {

        series: [
          {
            type: 'gauge',
            startAngle: 225,
            endAngle: -45,
            radius: '90%',
            itemStyle: {
              color: '#EBB908',
              shadowColor: 'rgba(236,186,10,0.45)',
              shadowBlur: 10,
              shadowOffsetX: 1,
              shadowOffsetY: 1,
            },
            progress: {
              show: true,
              roundCap: true,
              width: 6,
            },
            pointer: {
              icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
              length: '75%',
              width: 6,
              offsetCenter: [0, '5%'],
            },
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 6,
              },
            },
            axisTick: {
              splitNumber: 2,
              lineStyle: {
                width: 2,
                color: '#999',
              },
            },
            splitLine: {
              length: 10,
              lineStyle: {
                width: 3,
                color: '#999',
              },
            },
            axisLabel: {
              distance: 8,
              color: '#999',
              fontSize: 14,
            },
            detail: {
              valueAnimation: true,
              precision: 1,
              fontSize: 16,
              offsetCenter: [0, '80%'],
              formatter: `{value|${this.hostInfo.Host.Memory_usage}%}`,
              rich: {
                small: {
                  fontSize: 12,
                  color: this.skinType ? '#fff' : '#333',
                  lineHeight: 0,
                },
                value: {
                  fontSize: 16,
                  color: '#EBB908',
                  fontWeight: 'bold',
                },
              },
            },
            title: {
              offsetCenter: [0, '100%'],
              fontWeight: 'bold',
              color: this.skinType ? '#fff' : '#000',
            },
            data: [
              {
                value:
                  parseFloat(this.hostInfo.Host.Memory_usage),
                name: '内存',
              },
            ],
          },
        ],
      };
    },
    usageDiskC() {
      if (this.hostInfo == null) {
        return null;
      }
      return {
        color: [{
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#4081FF', // 0% 处的颜色
          }, {
            offset: 1, color: '#34ACFF', // 100% 处的颜色
          }],
        }],
        series: [{
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          pointer: {
            show: false,
          },
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
          },
          axisLine: {
            lineStyle: {
              width: 10,
            },
          },
          splitLine: {
            show: false,
            distance: 0,
            length: 10,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            distance: 50,
          },
          data: [{
            value: this.hostInfo.Host.Disk_Info[0].Usage,
            name: `[${this.hostInfo.Host.Disk_Info[0].Volume}]`,
            title: {
              offsetCenter: ['0%', '-20%'],
            },
            detail: {
              offsetCenter: ['0%', '20%'],
            },
          },
          ],
          title: {
            fontSize: 14,
            textStyle: {
              color: this.skinType ? '#fff' : '#333',
            },
          },
          detail: {
            width: 50,
            height: 14,
            fontSize: 14,
            color: this.skinType ? '#fff' : '#000',
            borderColor: 'auto',
            borderRadius: 20,
            borderWidth: 1,
            formatter: '{value}%',
          },
        }],
      };
    },
    usageDiskD() {
      if (this.hostInfo == null) {
        return null;
      }
      return {
        color: [{
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#FF7B05', // 0% 处的颜色
          }, {
            offset: 1, color: '#FAB87D', // 100% 处的颜色
          }],
        }],
        series: [{
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          pointer: {
            show: false,
          },
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
          },
          axisLine: {
            lineStyle: {
              width: 10,
            },
          },
          splitLine: {
            show: false,
            distance: 0,
            length: 10,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            distance: 50,
          },
          data: [{
            value: this.hostInfo.Host.Disk_Info[1].Usage,
            name: `[${this.hostInfo.Host.Disk_Info[1].Volume}]`,
            title: {
              offsetCenter: ['0%', '-20%'],
            },
            detail: {
              offsetCenter: ['0%', '20%'],
            },
          },
          ],
          title: {
            fontSize: 14,
            textStyle: {
              color: this.skinType ? '#fff' : '#333',
            },
          },
          detail: {
            width: 50,
            height: 14,
            fontSize: 14,
            color: this.skinType ? '#fff' : '#000',
            borderColor: 'auto',
            borderRadius: 20,
            borderWidth: 1,
            formatter: '{value}%',
          },
        }],
      };
    },
    // 用能趋势
    trendAnalysis() {
      if (this.usageList == null) {
        return null;
      }
      return {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['CPU', '内存', '硬盘'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.usageList.xAxisData,
          axisLabel: {
            color: this.skinType ? '#fff' : '#333',
          },
          axisLine: {
            color: this.skinType ? '#fff' : '#333',
          },
        },
        yAxis: {
          name: '%',
          type: 'value',
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: this.skinType ? '#fff' : '#333',
            },
          },
          axisLine: {
            color: this.skinType ? '#fff' : '#333',
          },
          axisLabel: {
            color: this.skinType ? '#fff' : '#333',
          },
        },
        series: this.usageList.seriesData.map((item) => ({
          name: item.Name,
          data: item.Data.map((val) => parseFloat(val).toFixed(2)),
          type: 'line',
        })),
      };
    },
    flowMonitoring() {
      if (this.usageList == null) {
        return null;
      }
      return {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['CPU', '内存', '硬盘'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.flowList.xAxisData,
          axisLabel: {
            color: this.skinType ? '#fff' : '#333',
          },
          axisLine: {
            color: this.skinType ? '#fff' : '#333',
          },
        },
        yAxis: {
          name: 'kB',
          type: 'value',
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: this.skinType ? '#fff' : '#333',
            },
          },
          axisLine: {
            color: this.skinType ? '#fff' : '#333',
          },
          axisLabel: {
            color: this.skinType ? '#fff' : '#333',
          },
        },
        series: this.flowList.seriesData.map((item) => ({
          name: item.Name,
          data: item.Data.map((val) => parseFloat(val).toFixed(2)),
          type: 'line',
        })),
      };
    },
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  watch: {
    selectDate() {
      this.requestDataRang();
    },
    selectDate1() {
      this.requestFlowMonitoring();
    },
  },
  methods: {
    requestHostInfo() {
      getHostInfo()
        .then((res) => {
          this.hostInfo = res;
          this.getServiceMonitorList();
        })
        .catch((err) => {
          console.log(err);
        })
        .then(() => {
          if (this.routeName !== this.$route.name) {
            return;
          }
          setTimeout(this.requestHostInfo, 5 * 1000);
        });
    },
    getServiceMonitorList() {
      const valList = [];
      const keys = Object.keys(this.hostInfo.Host);
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        const name = this.serviceMonitorMap.get(key);
        if (name) {
          valList.push({
            name,
            value:
              key === 'SYS_runningTime'
                ? (this.hostInfo.Host[key] / 24 / 60 / 60 / 1000).toFixed(1)
                : this.hostInfo.Host[key],
            unit: this.serviceMonitorUnitMap.get(key),
          });
        }
      }
      this.serviceMonitorList = valList;
    },
    requestDataRang() {
      clearTimeout(this.trendAnalysisTimeout);
      const [StartTime, EndTime] = [
        `${this.selectDate} 00:00:00`,
        `${this.selectDate} 23:59:59`,
      ];
      const params = {
        StartTime,
        EndTime,
        DataTypeList: 'CPU_usage,Memory_usage,Disk_C_usage,Disk_D_usage',
      };
      getDataRang(params)
        .then((res) => {
          this.usageList = res;
        })
        .catch()
        .then(() => {
          if (
            this.routeName !== this.$route.name
            || this.selectDate !== formatDate(new Date(), 'yyyy-MM-dd')
          ) {
            return;
          }
          this.trendAnalysisTimeout = setTimeout(
            this.requestDataRang,
            5 * 1000,
          );
        });
    },
    requestFlowMonitoring() {
      clearTimeout(this.flowMonitoringTimeout);
      const [StartTime, EndTime] = [
        `${this.selectDate1} 00:00:00`,
        `${this.selectDate1} 23:59:59`,
      ];
      const params = {
        StartTime,
        EndTime,
        DataTypeList: 'Net_SentRate,Net_ReceivedRate',
      };
      getDataRang(params)
        .then((res) => {
          this.flowList = res;
        })
        .catch()
        .then(() => {
          if (
            this.routeName !== this.$route.name
            || this.selectDate !== formatDate(new Date(), 'yyyy-MM-dd')
          ) {
            return;
          }
          this.flowMonitoringTimeout = setTimeout(
            this.requestFlowMonitoring,
            5 * 1000,
          );
        });
    },
  },
};
</script>
<style scoped>
.small {
  font-size: 12px;
}
.service-monitor-container {
  background-color: transparent;
  margin-bottom: 1rem;
}
</style>
